import { render, staticRenderFns } from "./IconExportDoc.vue?vue&type=template&id=4fa00d2f"
import script from "./IconExportDoc.vue?vue&type=script&lang=js"
export * from "./IconExportDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports